import { Dialog } from '@mui/material';
import { ButtonComponent } from 'component/Button';
import { React, useState } from 'react';
import { ReactComponent as CancelSvg } from 'assets/images/icons/close_24px.svg';
import { ReactComponent as AddSvg } from 'assets/images/icons/add_24px.svg';
import { InputComponent } from 'component/Input';
import { TextareaComponent } from 'component/Textarea';
import { SelectComponent } from 'component/Select';
import { axiosWrapper } from 'utils/Helper';
import { setNewDonor } from 'api/DonorsApi';
import { getOrganizations } from 'api/CustomersApi';
import { toast } from 'react-toastify';

function buildOrganizationOptions(list) {
  const organizations = Array.isArray(list) ? list : [];
  return organizations.map((organization) => {
    const label =
      organization.full_name_uk?.trim() ||
      organization.name ||
      organization.abbreviation ||
      String(organization.id);
    return { value: organization.id, label };
  });
}

export const NewDonor = (props) => {
  const [open, setOpen] = useState(false);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
    axiosWrapper(() => {
      getOrganizations()
        .then((res) => {
          const list = res?.data?.results ?? res?.data;
          setOrganizationOptions(buildOrganizationOptions(list));
        })
        .catch(() => setOrganizationOptions([]));
    });
  };

  const handleClose = () => {
    setOpen(false);
    props.setName(null);
    props.setDescription(null);
    setSelectedOrganizations([]);
  };

  const createNewDonor = () => {
    if (!props.description) {
      toast.warning('You need to set description');
      return;
    }
    if (!selectedOrganizations?.length) {
      toast.warning('Select at least one organization');
      return;
    }
    props.setLoader(true);
    axiosWrapper(() => {
      const body = {
        name: props.name,
        description: props.description,
        organizations: selectedOrganizations.map((option) => option.value),
      };
      setNewDonor(body)
        .then(() => {
          toast.success('Donor created');
          props.setLoader(false);
          props.getDonorsList(1);
          handleClose();
        })
        .catch((err) => {
          console.error(err);
          toast.error('Donor not created');
          props.setLoader(false);
          handleClose();
        });
    });
  };

  return (
    <div className="buttons-group">
      <ButtonComponent
        iconLeft={<AddSvg />}
        handleButton={handleClickOpen}
        label="New donor"
        className=""
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="confirm-popup donor-form-popup">
          <div className="header">
            <span className="title">Create donor</span>
            <span className="closeBtn" onClick={handleClose} />
          </div>

          <div className="flex-column-group">
            <InputComponent
              id="donor-name"
              name="donor-name"
              label="Donor name"
              placeholder="Donor name"
              value={props.name}
              handleInput={props.setName}
              classNameWrapper="align-left"
            />
            <div className="input-wrapper align-left w-100" style={{ marginTop: '10px' }}>
              <div className="labels">
                <label htmlFor="donor-description">Donor description</label>
              </div>
              <div className="textarea-wrapper w-100">
                <TextareaComponent
                  id="donor-description"
                  name="donor-description"
                  placeholder="Donor description"
                  value={props.description}
                  handleTextarea={props.setDescription}
                  minRows={1}
                  maxRows={20}
                  style={{ width: '100%', boxSizing: 'border-box', minHeight: 'unset' }}
                />
              </div>
            </div>
            <div className="select-wrapper w-100" style={{ marginTop: '10px' }}>
              <span className="label">Organizations</span>
              <SelectComponent
                className="w-100"
                placeholder="Select organizations..."
                value={selectedOrganizations}
                options={organizationOptions}
                handleSelect={(selected) =>
                  setSelectedOrganizations(Array.isArray(selected) ? selected : [])
                }
                isMulti
                menuPortalTarget={document.body}
                menuPosition="fixed"
                noOptionsMessage={() => 'No organizations'}
                customStyles={{
                  menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                  menu: (base) => ({ ...base, zIndex: 2000 }),
                }}
              />
            </div>
          </div>

          <div className="buttons-group">
            <ButtonComponent
              className="danger"
              iconLeft={<CancelSvg />}
              handleButton={() => {
                handleClose();
              }}
              label="Close"
            />
            <ButtonComponent
              iconLeft={<AddSvg />}
              handleButton={createNewDonor}
              label="Create"
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};
